import { abstractHooks } from '@datadog/browser-core';
export var createHooks = abstractHooks;